import React from 'react';
import BracketConnector from '../BracketConnector';
import { CARD_WIDTH, CARD_HEIGHT } from '../../bracketLayout';
import { cardY } from './geometry';
import connectorStyles from '../BracketConnector/BracketConnector.module.scss';

// Conector en T para Semi → Final
const buildFinalConnector = (srcEntry, destEntry, color) => {
  const { effectiveIdx: ei, x: sx } = srcEntry;
  const { effectiveIdx: nei, x: dx } = destEntry;

  const sf0 = cardY(ei, 0, false) + CARD_HEIGHT / 2;
  const sf1 = cardY(ei, 1, false) + CARD_HEIGHT / 2;
  const finC = cardY(nei, 0, true) + CARD_HEIGHT / 2;
  const trdC = cardY(nei, 1, true) + CARD_HEIGHT / 2;
  const meetY = (finC + trdC) / 2;

  const pivotX = dx + CARD_WIDTH / 2;
  const svgL = sx + CARD_WIDTH;
  const svgT = Math.min(sf0, finC) - 2;
  const svgB = Math.max(sf1, trdC) + 2;
  const svgW = pivotX - svgL;
  const svgH = svgB - svgT;

  const y1 = sf0 - svgT;
  const y2 = sf1 - svgT;
  const yM = meetY - svgT;

  const stemTop = (cardY(nei, 0, true) + CARD_HEIGHT) - svgT;
  const stemBot = cardY(nei, 1, true) - svgT;

  const ENTRY = 10;
  const MAX_R = 24;
  const R = Math.max(
    4,
    Math.min(MAX_R, Math.abs(y1 - yM), svgW - ENTRY - 4),
  );
  const mergeX = ENTRY + R;

  const topPath = [
    `M 0 ${y1}`,
    `L ${ENTRY} ${y1}`,
    `A ${R} ${R} 0 0 1 ${mergeX} ${y1 + R}`,
    `L ${mergeX} ${yM}`,
    `L ${svgW} ${yM}`,
  ].join(' ');

  const botPath = [
    `M 0 ${y2}`,
    `L ${ENTRY} ${y2}`,
    `A ${R} ${R} 0 0 0 ${mergeX} ${y2 - R}`,
    `L ${mergeX} ${yM}`,
    `L ${svgW} ${yM}`,
  ].join(' ');

  const stemPath = `M ${svgW} ${stemTop} L ${svgW} ${stemBot}`;

  return (
    <svg
      key="c-semi-final"
      className={connectorStyles['bracket-connector']}
      style={{
        position: 'absolute',
        top: svgT, left: svgL, width: svgW, height: svgH,
        overflow: 'visible',
        pointerEvents: 'none',
      }}
      viewBox={`0 0 ${svgW} ${svgH}`}
      aria-hidden="true"
    >
      <path d={topPath} stroke={color} fill="none" strokeWidth="1" vectorEffect="non-scaling-stroke" />
      <path d={botPath} stroke={color} fill="none" strokeWidth="1" vectorEffect="non-scaling-stroke" />
      <path d={stemPath} stroke={color} fill="none" strokeWidth="1" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export const buildConnectors = entries => {
  const out = [];
  const connColor = 'var(--bracket-connector-color)';

  for (let i = 0; i < entries.length - 1; i++) {
    const { round: r, effectiveIdx: ei, x: sx } = entries[i];
    const { round: nr, effectiveIdx: nei, x: dx } = entries[i + 1];

    if (nr.id === 'final') {
      out.push(buildFinalConnector(entries[i], entries[i + 1], connColor));
      continue;
    }

    nr.matches.forEach((m, ni) => {
      const ti = ni * 2;
      const bi = ni * 2 + 1;
      if (!r.matches[ti] || !r.matches[bi]) return;

      out.push(
        <BracketConnector
          key={`c-${r.id}-${m.id}`}
          topMatch={{
            x: sx + CARD_WIDTH,
            y: cardY(ei, ti, r.id === 'final'),
            height: CARD_HEIGHT,
          }}
          bottomMatch={{
            x: sx + CARD_WIDTH,
            y: cardY(ei, bi, r.id === 'final'),
            height: CARD_HEIGHT,
          }}
          resultMatch={{ x: dx, y: cardY(nei, ni, false), height: CARD_HEIGHT }}
        />,
      );
    });
  }
  return out;
};
